<template>
  <div class="list-container">
    <!-- Organization Tabs Component -->
    <OrganizationTabs
      ref="organizationTabsRef"
    />

    <div v-if="selectedOrganization" class="details-container">
      <!-- Organization Header -->
      <div class="details-header">
        <div class="title-stack">
          <ImageThumbnail
            v-if="selectedOrganization.logo_url"
            :url="selectedOrganization.logo_url"
            max-height="100px"
          />
          <h1>{{ selectedOrganization.name }}</h1>
          <RoleBadges :roles="selectedOrganization.member_roles" />
        </div>
        <div class="spacer"></div>
        <div class="details-actions" v-if="canEditOrganization(selectedOrganization.id)">
          <router-link
            :to="`/organizations/${selectedOrganization.id}/edit`"
            class="important-button big"
          >
            <font-awesome-icon icon="edit" /> Edit Organization
          </router-link>
        </div>
      </div>

      <!-- Organization Details -->
      <div class="details-section">
        <h3>Information</h3>
        <div class="details-group half-width">
          <label>Website URL</label>
          <div class="details-value">
            <a v-if="selectedOrganization.website_url" :href="selectedOrganization.website_url" target="_blank" rel="noopener noreferrer">
              {{ selectedOrganization.website_url }}
            </a>
          </div>
        </div>

        <div class="details-group half-width">
          <label>Phone</label>
          <div class="details-value">{{ selectedOrganization.phone }}</div>
        </div>

        <div class="details-group full-width">
          <AddressDetails 
            :address_line_1="selectedOrganization?.address_line_1"
            :address_line_2="selectedOrganization?.address_line_2"
            :city="selectedOrganization?.city"
            :state="selectedOrganization?.state"
            :postal_code="selectedOrganization?.postal_code"
            :country="selectedOrganization?.country"
          />
        </div>
      </div>

      <!-- Organization Members -->
      <OrganizationMembers 
        v-if="canViewUsers(selectedOrganization.id)"
        :organization-id="selectedOrganization.id" 
        :read-only="!canEditUsers(selectedOrganization.id)"
      />
    </div>

    <div v-else>
      <div class="details-header">
        <h1>Organization</h1>
      </div>
      <div class="message">
        <div>
          You are not a member of an organization.
        </div>
        <NewOrganizationButton />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import ImageThumbnail from '@/components/ImageThumbnail.vue';
import OrganizationMembers from '@/components/OrganizationMembers.vue';
import RoleBadges from '@/components/RoleBadges.vue';
import NewOrganizationButton from '@/components/NewOrganizationButton.vue';
import OrganizationTabs from '@/components/OrganizationTabs.vue';
import { canEditOrganization, canViewUsers, canEditUsers } from '@/scripts/permissions';
import AddressDetails from '@/components/AddressDetails.vue';

const organizationTabsRef = ref(null);
const selectedOrganization = computed(() => organizationTabsRef.value?.selectedOrganization);
</script>

<style scoped>
@import '@/styles/shared-tabs.css';
@import '@/styles/shared-details.css';
</style>
